export default __webpack_public_path__ + "images/box1.png?c7ab9a3f";